import { emptyObj } from 'util/objects'
import { base } from './base'

export const selectCounts = state => base(state).counts || emptyObj
